module.exports = __webpack_public_path__ + "img/s2remark-mobile.63e04d03.png";